import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import AuthorizeOrGuestLogin from "../../AuthorizeOrGuestLogin";
import styled from "styled-components";

const CheckoutLoginNew = (props) => {
  const { currentStep = {}, stepAction = () => {} } = props;
  const { step = 0 } = currentStep;

  const userProfileInfo = useSelector(
    (state) => state.userDetails?.userProfile || {}
  );
  const { fullName = "", phoneNo = "" } = userProfileInfo;

  const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    width: 99%;
    margin-right: 2rem;
    border-radius: 8px;

    `
const LoginMessage = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;

align-items: flex-start;
width: 100%;
min-height: 200px;
background-color: #fff;
border-radius: 8px;
border: 1px solid rgba(0, 0, 0, 0.12);
  padding:1rem;
  font-size: 1rem;

`
const LoggedInAs = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: flex-start;
width: 100%;
min-height: 31px;
border-radius: 8px;
width: 100%;


    padding:1rem;
    font-size: 1rem;
    margin-bottom: 1rem;

    .loggedas {
      font-size: 0.9rem;
      color: rgb(130, 130, 130);
      
    }
`

  return (
   <LoginContainer>
    { step === 1 ? <>
    <LoginMessage>
     Please login to continue with your order.
    </LoginMessage>
    </>:<>
    <LoggedInAs>
     <div className="loggedas">Logged in as</div> <div>{fullName}</div>
    </LoggedInAs>
    </>}
   </LoginContainer>

  );
};

export default CheckoutLoginNew;
